module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/point3_526b782f4518837df4206c486dfc072e.png";